export const MFASteps = {
    AskMeAgain : 1,
    SmsEnrollment : 2,
    ActivateFactor : 3,
    IssueFactor : 4,
    CodeVerify : 5,
    ConfirmationCode : 6,
    ChooseFactor: 7,
    EmailEnrollment: 8,
    ErrorMessagePage: 9
}

export const  MFA = {
    goBack : 'Go Back',
    done: 'Done',
    factorType: {
        sms: 'sms',
        email: 'email'
    },
    FACTORS : {
        EMAIL : 0,
        SMS : 1
    },
    ActivateFactor: {
        smsTitle : 'Enter code from text message',
        emailTitle : 'Enter code from email',
        smsDescription : 'A 6-digit code was sent to',
        emailDescription : 'A 6-digit code was sent to your email address',
        incorrectCodeMessage : 'Code entered is incorrect.',
        enterCode : 'Enter Code',
        enterCodeEmail : 'Enter code from Email',
        enterCodeSms : 'Enter code from SMS',
        enterCodeEmailAriaDescription : 'Enter code from email',
        enterCodeSmsAriaDescription : 'Enter code from text message',
        didNotReceiveText : 'Didn\'t receive the code?',
        ResendCode : 'Resend code',
        sent : 'Sent',
        verify : 'Verify'        
    },
    AskMeAgain: {
        title: 'Would you like to turn on two-step verification?',
        description: 'Two-step verification gives you an extra layer of security. After you turn this on, you\'ll be asked to enter a 6-digit code sent via email or text when you sign in.',
        getStarted: 'Get Started',
        askMeAgainLater: 'Ask Me Again Later'
    },
    ChooseFactor: {
        title:  'Set up two-step verification',
        smsTextTitle : 'Text Message Verification',
        emailTextTitle:  'Email Verification',        
        smsText:  'Get one-time-use codes sent to your phone number',
        emailText:  'Get one-time-use codes sent to your email',
        buttonText:  'Text Set Up',
        buttonEmailText:  'Email Set Up',
        additionalOptions: 'Additional options',
        textMessageVerification: 'Text Message Verification',
        emailVerification: 'Email Verification'
    },
    ConfirmationCode: {
        title: 'Set Up Complete',
        description: 'Two-step verification settings can be adjusted on your',
        receiveVerificationsCodeVia: 'You are set up to receive verification codes via:',
        emailVerification: 'Email Verification',
        smsSetupAriaDescription: 'Set up Text message Verification',
        emailSetupAriaDescription: 'Set up Email Verification',
        textMessageVerification: 'Text Message Verification'
    },
    SmsEnrollment: {
        title: 'Set up text message verification',
        description: 'You are consenting to be contacted at the phone number selected for the purpose of receiving an authorization code. If you selected text message, Wireless and text message fees may apply from your carrier.',
        mobileNumber: 'Mobile Number',
        sendCode: 'Send Code',
         updateTitle: 'Update phone number',
        invalidPhoneNumber: 'Enter 10-digit mobile number'
    }, 
    SmsUpdate: {
        title: 'Update phone number',
        description: 'You are consenting to be contacted at the phone number selected for the purpose of receiving an authorization code. If you selected text message, Wireless and text message fees may apply from your carrier.',
        mobileNumber: 'Mobile Number',
        sendCode: 'Send Code', 
        invalidPhoneNumber: 'Enter 10-digit mobile number'
    },
    EmailEnrollment: {
        title: 'Set up email verification',
        textTitle: 'Email Verification',
        buttonText: 'Send Code',
        text: 'We will send a verification code to ',
    },
    StepVerification: {
        title: 'Request verification code',
        textTitleSMS: 'Text Message Verification',
        textTitleEmail: 'Email Verification',
        buttonTextEmail: 'Send Code via Email',
        buttonTextSMS: 'Send Code via Text',
        text: 'We will send a verification code to ',
    }
}